import NewsWidget from './NewsWidget'
export { NewsWidget }
export default NewsWidget
